import { render, staticRenderFns } from "./PasswordEditor.vue?vue&type=template&id=71c2ddc6"
import script from "./PasswordEditor.vue?vue&type=script&lang=js"
export * from "./PasswordEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports